import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDisableWorkbookAccelerationParams {
  targetIds: string[];
}

export class DisableWorkbookAccelerationRequest extends Request<IDisableWorkbookAccelerationParams, IResult> {
  constructor(params: IDisableWorkbookAccelerationParams) {
    super('disableWorkbookAcceleration', params);
  }
}
